import { CONSORS_PURPOSES_OF_LOAN } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsPurposeOfLoan = z.nativeEnum(CONSORS_PURPOSES_OF_LOAN);

export type SchemaConsorsPurposeOfLoan = z.infer<typeof schemaConsorsPurposeOfLoan>;
